import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import PortfolioCard from "@/components/PortfolioCard";
import { Reveal } from "@/components/Reveal";
import { useSEO } from "@/hooks/useSEO";
import { IMG, wa } from "@/lib/site";

// 6 kategori tetap. Untuk menambah dokumentasi klien baru pada satu kategori,
// cukup tambahkan URL gambar ke array `images` — slider akan aktif otomatis.
const PORTFOLIO = [
  { label: ["Kaos", "(T-Shirt)"], client: "Angkringan Party HI UPN", images: [IMG.tshirt, IMG.jersey] },
  { label: ["Polo", "Shirt"], client: "Semesta Coffee & Eatery", images: [IMG.tailoring, IMG.textureWhite] },
  { label: ["Kemeja", "(PDH & PDL)"], client: "SDN 13 Sungai Melayu Rayak", images: [IMG.tailoring, IMG.jacket, IMG.factory] },
  { label: ["Jaket &", "Sweater"], client: "Bintang Medika Cilacap", images: [IMG.jacket, IMG.tailoring] },
  { label: ["Professional", "Shirt"], client: "Five-O Barbershop", images: [IMG.design, IMG.factory] },
  { label: ["Rompi", "(Vest)"], client: "Koat Coffee", images: [IMG.jacket, IMG.tailoring, IMG.textureWhite] },
];

export default function Portofolio() {
  useSEO(
    "Portofolio",
    "Portofolio HATTORY KONVEKSI — dokumentasi hasil produksi apparel custom: kaos, polo, kemeja, jaket, professional shirt, dan rompi untuk berbagai klien."
  );

  return (
    <>
      <PageHero
        overline="Portofolio"
        titleLines={["Portofolio", "Kami"]}
        description="Dokumentasi hasil produksi kami untuk berbagai klien. Geser tiap kategori untuk melihat lebih banyak contoh."
      />

      <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
        <div className="grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-testid="portfolio-grid">
          {PORTFOLIO.map((item, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <PortfolioCard item={item} index={i} />
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-20 flex flex-col items-center justify-center gap-4 rounded-3xl border border-silver/40 px-8 py-14 text-center sm:flex-row">
            <Link
              to="/produk"
              data-testid="portfolio-products-btn"
              className="inline-flex items-center gap-2 rounded-full bg-navy px-8 py-4 font-medium text-white transition-transform duration-300 hover:scale-105"
            >
              Lihat Kategori Produk <ArrowRight className="h-5 w-5" />
            </Link>
            <a
              href={wa("Halo HATTORY KONVEKSI, boleh saya lihat contoh hasil produksi Anda?")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="portfolio-wa-btn"
              className="inline-flex items-center gap-2 rounded-full border border-silver px-8 py-4 font-medium text-navy transition-colors hover:bg-surface"
            >
              <MessageCircle className="h-5 w-5" /> Tanya Contoh Hasil via WhatsApp
            </a>
          </div>
        </Reveal>
      </div>

      <CTABand />
    </>
  );
}
